import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import RadioGroup from "@mui/material/RadioGroup";
import { FormField, Separator, useTranslations } from "@jti/ui";
import styles from "./DeliveryOptions.module.scss";
export const DeliveryOptions = ({ name, children }) => {
    const { __ } = useTranslations();
    return (_jsxs(_Fragment, { children: [_jsx(Separator, {}), _jsx("p", { children: __("cart.checkout.delivery.options_description") }), _jsx(FormField, { className: styles.radios, name: name, validation: { required: __("validation.field_required") }, render: ({ field }) => _jsx(RadioGroup, { ...field, children: children }) })] }));
};
//# sourceMappingURL=DeliveryOptions.js.map